import React from "react";
import { useTranslation } from "react-i18next";

// Assets
import "~/assets/sass/pages/invest/IrModal/member.scss";
import LightDefaultProfileImg from "~/assets/img/defaultImg/light-profile-large.png";
import DarkDefaultProfileImg from "~/common/components/Images";
import { useGlobalStore } from "~/store";

const MemberView = ({ irMember }) => {
	const [
		{
			theme: { theme },
		},
	] = useGlobalStore();
	const { t } = useTranslation();
	return (
		<>
			<div className="c__cardRow member-view">
				{irMember.map((d) => (
					<div className="c__card">
						<div className="member-img">
							<img
								src={
									d.img === ""
										? theme === "dark"
											? DarkDefaultProfileImg
											: LightDefaultProfileImg
										: d.img
								}
								alt={t(
									"pages.investment.InvestEvalPage.detail.modal.member.imageAlt"
								)}
							/>
						</div>
						<dl className="card-content">
							<dt className="member-name">{d.name}</dt>
							<dd className="member-position">
								<span>
									{d.department} {d.position}
								</span>
							</dd>
							<dd className="member-career">
								{d.introduction === ""
									? t(
											"pages.investment.InvestEvalPage.detail.modal.member.alert01"
									  )
									: d.introduction}
							</dd>
						</dl>
					</div>
				))}
			</div>
		</>
	);
};

export default MemberView;
